import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: 'NAME_KEY',
    stateKey: 'first_name',
  },
  {
    gridXs: 12,
    label: 'LAST_NAME_KEY',
    stateKey: 'last_name',
  },
  {
    gridXs: 12,
    label: 'EMAIL_KEY',
    stateKey: 'email',
    disabled: true,
  },
];

export default fields;
